<template>
    <div class="voteList">
        <el-breadcrumb class="bread-nav" separator="/">
            <el-breadcrumb-item>首页</el-breadcrumb-item>
            <el-breadcrumb-item>投票</el-breadcrumb-item>
            <el-breadcrumb-item>查询项目</el-breadcrumb-item>
        </el-breadcrumb>
        <el-table class="vote-list-table" :data="voteList" stripe border>
            <el-table-column label="项目ID" align='center' width="100px">
                <template scope="scope">
                    <span>{{scope.row.vote_id}}</span>
                </template>
            </el-table-column>
            <el-table-column label="标题" align='center'>
                <template scope="scope">
                    <span>{{scope.row.vote_name}}</span>
                </template>
            </el-table-column>
            <el-table-column label="链接" align='center'>
                <template scope="scope">
                    <a target="_blank" :href="baseUrl + scope.row.vote_id">{{baseUrl + scope.row.vote_id}}</a>
                </template>
            </el-table-column>
            <el-table-column label="创建者" align='center'  width="120px">
                <template scope="scope">
                    <span>{{scope.row.userName}}</span>
                </template>
            </el-table-column>
            <el-table-column label="操作" align='center' width="200px">
                <template scope="scope">
                    <el-button size="small" type="info" @click="openEditDialog(scope.$index)">编辑</el-button>
                    <el-button size="small" type="danger" @click="deleteVote(scope.row.vote_id)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-dialog title="编辑项目" v-model="config.editVote.visible" :lock-scroll="true" @close="clearDialogData">
            <el-form :model="editVoteForm" :rules="config.editVote.validateRules" ref="editVoteForm">
                <el-form-item label="标题" :label-width="config.editVote.formLabelWidth" prop="vote_name">
                    <el-input type="text" v-model="editVoteForm.vote_name" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="描述" :label-width="config.editVote.formLabelWidth" prop="vote_content">
                    <el-input type="textarea" v-model="editVoteForm.vote_content" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="焦点图" :label-width="config.editVote.formLabelWidth" prop="bgimg">
                    <el-input v-model="editVoteForm.bgimg" placeholder="请填写焦点图（尺寸2：1）链接"></el-input>
                </el-form-item>
                <el-form-item class="vote-start-end-time-box" label="起止时间" :label-width="config.editVote.formLabelWidth" prop="vote_start_end_time">
                    <el-date-picker v-model="editVoteForm.vote_start_end_time" type="datetimerange" :editable="false" :picker-options="pickerOptions" placeholder="选择时间范围" align="left"></el-date-picker>
                </el-form-item>
                <el-form-item class="is_share_box" :label-width="config.editVote.formLabelWidth" label="自定义分享" prop="is_share">
                    <el-switch @change="changeIsShareFlag" v-model="editVoteForm.is_share" on-color="#13ce66" off-color="#ff4949" on-value="1" off-value="0"></el-switch>
                </el-form-item>
                <template v-if="editVoteForm.is_share === '1'">
                    <el-form-item :label-width="config.editVote.formLabelWidth" label="分享标题" prop="share_title">
                        <el-input v-model="editVoteForm.share_title" placeholder="请填写分享标题"></el-input>
                    </el-form-item>
                    <el-form-item :label-width="config.editVote.formLabelWidth" label="分享描述" prop="share_content">
                        <el-input v-model="editVoteForm.share_content" placeholder="请填写分享描述"></el-input>
                    </el-form-item>
                    <el-form-item :label-width="config.editVote.formLabelWidth" label="分享图" prop="share_img">
                        <el-input v-model="editVoteForm.share_img" placeholder="请填写分享图链接"></el-input>
                    </el-form-item>
                </template>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="config.editVote.visible = false">取 消</el-button>
                <el-button type="primary" @click="updateVote('editVoteForm')">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import CONFIG from "@/config/index.js";
import TOOL from '@/tool/index.js';
import router from "@/router/index.js";
import { mapGetters } from 'vuex';
export default {
    name: "businessList",
    data() {
        return {
            voteList: null,
            baseUrl: CONFIG.HOST + "/wxAuth/wx_login?hUri=" + CONFIG.HOST + '/voteExport/getVoteById/',
            editVoteForm: {
                vote_id: null,
                vote_name: null,
                vote_content: null,
                vote_start_end_time: null,
                is_share: '0',
                share_title: null,
                share_content: null,
                share_img: null,
                bgimg: null
            },
            config: {
                editVote: {
                    visible: false,
                    formLabelWidth: '120px',
                    validateRules: {
                        vote_name: [
                            { required: true, message: '请填写选项名称', trigger: 'blur' }
                        ],
                        vote_content: [
                            { required: true, message: '请填写选项描述', trigger: 'blur' }
                        ],
                        vote_start_end_time: [
                            { type: 'array', required: true, message: '请选择投票起止时间', trigger: 'blur' }
                        ],
                        is_share: [
                            { required: true, message: '请设置选择自定义分享', trigger: 'blur' }
                        ],
                        bgimg: [
                            { required: true, message: '请填写焦点图链接', trigger: 'blur' }
                        ]
                    },
                }
            },
            pickerOptions: {
                shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近三个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                        picker.$emit('pick', [start, end]);
                    }
                }]
            }
        };
    },
    mounted(){
        this._init();
    },
    computed: {
        ...mapGetters({
            userInfo: 'getUserInfo'
        })
    },
    methods: {
        _getVoteList(){
            this.$http.get(CONFIG.HOST + '/voteSystem/vote/getVoteList').then((response)=>{
                let result =response.body;
                if (result && result.status === 1) {
                    this.voteList =result.data;
                } else {
                    this.$notify.error({
                        message: result.message
                    });
                }
            }, (response)=>{
                console.log(response);
            });
        },
        _confirmMessage(message, success = ()=>{}, cancel = ()=>{}) {
            this.$confirm(message, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(success).catch(cancel);          
        },
        deleteVote(voteId) {
            this._confirmMessage('是否确定删除voteId=' + voteId + '的投票项目？', ()=>{
                if (voteId < 0) {
                    this.$notify.error({
                        message: '【营销平台】voteId=' + voteId + '的投票项目不存在'
                    });
                    return;
                }
                this.$http.delete(CONFIG.HOST + '/voteSystem/vote/deleteVoteById/' + voteId).then((response)=>{
                    let result = response.body;
                    if (result && result.status === 1) {
                        this.$notify.success({
                            message: '【营销平台】成功删除voteId=' + voteId + '的投票项目'
                        });
                        this._getVoteList();
                    } else {
                        this.$notify.error({
                            message: result.message
                        });
                    }
                },(response)=>{
                    console.log(response);
                });
            });
        },
        updateVote(formName){
            let flag = true;
            this.$refs[formName].validate((valid) => {
                if (!valid) {
                    flag = false;
                    return false;
                }
            });
            if (!flag) {
                return;
            }
            this.$http.put(`${CONFIG.HOST}/voteSystem/vote/updateVote`, {
                vote_id: this.editVoteForm.vote_id,
                vote_name: this.editVoteForm.vote_name,
                vote_content: this.editVoteForm.vote_content,
                vote_start_time: (+new Date(this.editVoteForm.vote_start_end_time[0])),
                vote_end_time: (+new Date(this.editVoteForm.vote_start_end_time[1])),
                is_share: parseInt(this.editVoteForm.is_share),
                share_title: this.editVoteForm.share_title,
                share_content: this.editVoteForm.share_content,
                share_img: this.editVoteForm.share_img,
                bgimg: this.editVoteForm.bgimg
            }).then((response)=>{
                let result =response.body;
                if (result && result.status === 1) {
                    this.$notify.success({
                        message: `【营销平台】成功更新voteId= ${this.editVoteForm.vote_id} 的投票项目`
                    });
                    this._getVoteList();
                    this.config.editVote.visible = false;
                } else {
                    this.$notify.error({
                        message: result.message
                    });
                }
            }, (response)=>{
                console.log(response);
            });
        },
        clearDialogData(){
            for (let key in this.editVoteForm) {
                this.editVoteForm[key] = null;
            }
        },
        openEditDialog(arrIndex){
            this.config.editVote.visible = true;
            let curVote = this.voteList[arrIndex];
            for (let key in curVote) {
                if (key !== 'vote_start_end_time' && key !== 'vote_start_time' && key !== 'vote_end_time' && key !== 'is_share') {
                    this.editVoteForm[key] = curVote[key];
                }
            }
            this.editVoteForm.is_share = curVote['is_share'].toString();
            this.editVoteForm.vote_start_end_time = [new Date(moment(parseInt(curVote.vote_start_time)).format('YYYY-MM-DD HH:mm:ss')), new Date(moment(parseInt(curVote.vote_end_time)).format('YYYY-MM-DD HH:mm:ss'))];
            console.log(this.editVoteForm);
        },
        changeIsShareFlag(data){
            console.log(typeof data);
        },
        _init() {
            this._getVoteList();
        }
    }
};
</script>
<style lang="less">
    .voteList{
        width: 98%;
        margin: 0 auto;
        .bread-nav{
            margin: 20px 0;
        }
        .vote-list-table{
            min-width: 980px;
        }
        .page-control{
            margin: 20px auto 0 auto;
        }
        .vote-start-end-time-box{
            .el-form-item__content{
                width: 352px;
            }
        }
        .is_share_box{
            .el-form-item__content{
                width: 60px;
            }
        }
    }  
</style>


// WEBPACK FOOTER //
// List.vue?4f9f1480